import { Component } from '@angular/core';
import { EguardSplashScreenService } from './core/services/splash-screen.service';


@Component({
    selector: 'eguard-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    constructor(
        private eguardSplashScreen: EguardSplashScreenService,

    ) {
    }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts